// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedNewsItem_container__7KgBl","title":"RelatedNewsItem_title__76UW4","provider":"RelatedNewsItem_provider__4lF_M"};